import React from 'react';
import '../../styles/modes/customMode.css';

const PathActions = ({ 
  confirmPath, 
  resetPath, 
  customPath, 
  endId 
}) => {
  // Check if path includes the end point
  const hasEndPoint = endId && customPath.some(point => point.id === endId);
  
  // Generate appropriate tooltip message
  const getTooltipMessage = () => {
    if (!endId) {
      return "Please set an end point first";
    }
    if (customPath.length < 2) {
      return "Please select at least 2 points to create a path";
    }
    if (!hasEndPoint) {
      return "Please select a path that includes the end point";
    }
    return "Confirm this path";
  };
  
  return (
    <div className="custom-path-actions">
      {!endId && (
        <div className="path-warning">
          <p>Please set an end point</p>
        </div>
      )}
      
      <div className="action-buttons-row">
        <button 
          className="primary-button"
          onClick={confirmPath}
          disabled={customPath.length < 2 || !endId || !hasEndPoint}
          title={getTooltipMessage()}
        >
          Confirm Path
        </button>
        <button 
          className="reset-btn"
          onClick={resetPath}
          disabled={customPath.length === 0}
        >
          Reset Path
        </button>
      </div>
    </div>
  );
};

export default PathActions;
